import { GlSprintf, GlAccordion, GlAccordionItem } from '@gitlab/ui';
import { sprintf, translatePlural, translate } from '../../../../../utils/i18n';
import PreBlock from './pre_block';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var script = {
  name: 'CreateCommitToolParams',
  components: {
    GlSprintf,
    GlAccordion,
    GlAccordionItem,
    PreBlock
  },
  props: {
    projectId: {
      type: [String, Number],
      required: true
    },
    projectPath: {
      type: String,
      required: false,
      default: ''
    },
    branch: {
      type: String,
      required: true
    },
    startBranch: {
      type: String,
      required: false,
      default: ''
    },
    commitMessage: {
      type: String,
      required: true
    },
    actions: {
      type: Array,
      required: true
    }
  },
  computed: {
    actionsCount() {
      return this.actions.length;
    },
    actionsCountMessage() {
      return sprintf(translatePlural('CreateCommitToolParams.actionsCountMessage', 'The commit contains %{count} file change.', 'The commit contains %{count} file changes.')(this.actionsCount), {
        count: this.actionsCount
      });
    }
  },
  methods: {
    getActionTitle(_ref) {
      let {
        action,
        file_path: filePath,
        previous_path: previousPath
      } = _ref;
      switch (action) {
        case 'create':
          return sprintf(this.$options.i18n.CREATE_FILE_ACTION_LABEL, {
            filePath
          });
        case 'update':
          return sprintf(this.$options.i18n.UPDATE_FILE_ACTION_LABEL, {
            filePath
          });
        case 'delete':
          return sprintf(this.$options.i18n.DELETE_FILE_ACTION_LABEL, {
            filePath
          });
        case 'move':
          return sprintf(this.$options.i18n.MOVE_FILE_ACTION_LABEL, {
            filePath: previousPath
          });
        case 'chmod':
          return sprintf(this.$options.i18n.CHMOD_FILE_ACTION_LABEL, {
            filePath
          });
        default:
          return sprintf(this.$options.i18n.UNKNOWN_FILE_ACTION_LABEL, {
            filePath
          });
      }
    },
    getActionContent(_ref2) {
      let {
        action,
        content,
        encoding
      } = _ref2;
      if (!['create', 'update'].includes(action)) {
        return this.$options.i18n.ACTION_WITH_NO_CONTENT;
      }
      return (!encoding || encoding === 'text') && content ? content : '';
    }
  },
  i18n: {
    COMMIT_SUMMARY_MESSAGE: translate('CreateCommitToolParams.commitSummaryMessage', 'Create a commit in the branch %{branch} and project %{project}.'),
    READ_COMMIT_MESSAGE: translate('CreateCommitToolParams.readCommitMessage', 'Read commit message'),
    CREATE_FILE_ACTION_LABEL: translate('CreateCommitToolParams.createFileActionLabel', 'Create file %{filePath}'),
    UPDATE_FILE_ACTION_LABEL: translate('CreateCommitToolParams.updateFileActionLabel', 'Update file %{filePath}'),
    DELETE_FILE_ACTION_LABEL: translate('CreateCommitToolParams.deleteFileActionLabel', 'Delete file %{filePath}'),
    MOVE_FILE_ACTION_LABEL: translate('CreateCommitToolParams.moveFileActionLabel', 'Move file %{filePath}'),
    CHMOD_FILE_ACTION_LABEL: translate('CreateCommitToolParams.chmodFileActionLabel', 'Change permissions for file %{filePath}'),
    UNKNOWN_FILE_ACTION_LABEL: translate('CreateCommitToolParams.unknownFileActionLabel', 'Modify file %{filePath}'),
    ACTION_WITH_NO_CONTENT: translate('CreateCommitToolParams.actionWithNoContent', 'This action does not have any content.'),
    EXPAND_CHANGES: translate('CreateCommitToolParams.expandFileChanges', 'Expand file changes')
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-flex gl-flex-col"},[_c('div',[_c('gl-sprintf',{attrs:{"message":_vm.$options.i18n.COMMIT_SUMMARY_MESSAGE},scopedSlots:_vm._u([{key:"project",fn:function(){return [_c('code',[_vm._v(_vm._s(_vm.projectPath || _vm.projectId))])]},proxy:true},{key:"branch",fn:function(){return [_c('code',[_vm._v(_vm._s(_vm.branch))])]},proxy:true}])}),_vm._v("\n    "+_vm._s(_vm.actionsCountMessage)+"\n  ")],1),_vm._v(" "),_c('gl-accordion',{staticClass:"-gl-ml-2 gl-mt-3",attrs:{"header-level":3}},[_c('gl-accordion-item',{attrs:{"title":_vm.$options.i18n.READ_COMMIT_MESSAGE}},[_c('pre-block',[_vm._v(_vm._s(_vm.commitMessage))])],1),_vm._v(" "),_c('gl-accordion-item',{attrs:{"title":_vm.$options.i18n.EXPAND_CHANGES}},[_c('gl-accordion',{attrs:{"header-level":4}},_vm._l((_vm.actions),function(action,index){return _c('gl-accordion-item',{key:index,attrs:{"title":_vm.getActionTitle(action)}},[_c('pre-block',[_vm._v(_vm._s(_vm.getActionContent(action)))])],1)}),1)],1)],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
